import { render, staticRenderFns } from "./brand-table.vue?vue&type=template&id=09a1ac4a&scoped=true"
import script from "./brand-table.vue?vue&type=script&lang=js"
export * from "./brand-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a1ac4a",
  null
  
)

export default component.exports